import type { EIP1193Provider } from '../../EvmWalletProvider.types';

export const isEIP1193Provider = <T>(
  provider: T
): provider is EIP1193Provider & T => {
  return (
    provider !== null &&
    provider !== undefined &&
    typeof provider === 'object' &&
    'request' in provider &&
    typeof provider.request === 'function'
  );
};
